/* Azure Club — carrusel de reseñas: flechas + arrastre con el dedo */
(function () {
  var GAP = 16;

  function initCarousel(carousel) {
    if (carousel.dataset.reviewCarouselReady === '1') return;
    carousel.dataset.reviewCarouselReady = '1';

    var track = carousel.querySelector('[data-review-track]');
    if (!track) return;

    var prev = carousel.querySelector('[data-review-prev]');
    var next = carousel.querySelector('[data-review-next]');

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function refresh() {
      var max = maxScroll();
      var scrollable = max > 8;
      var pos = track.scrollLeft;
      if (prev) prev.hidden = !scrollable || pos <= 8;
      if (next) next.hidden = !scrollable || pos >= max - 8;
    }

    function stepWidth() {
      var item = track.querySelector('.review-carousel-item');
      if (!item) return track.clientWidth * 0.8;
      var w = item.getBoundingClientRect().width + GAP;
      var perView = Math.max(1, Math.round(track.clientWidth / w));
      return w * perView;
    }

    function go(direction) {
      track.scrollBy({ left: direction * stepWidth(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(refresh).observe(track);
    }

    refresh();
    setTimeout(refresh, 300);
    setTimeout(refresh, 1200);
    window.addEventListener('load', refresh);
  }

  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll('.review-carousel');
    for (var i = 0; i < nodes.length; i++) initCarousel(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
